export const ERROR_404 = '404'
export const ERROR_100450 = '100450'
export const ERRORS = [ERROR_404, ERROR_100450]
